import React, { Component } from "react";
import './default.css';

export default class JSDefault extends Component {

    render() {

        return(
            <div id = "defaultHeader">
                <h2>Welcome to the Javascript section!</h2>
                <p>This is just a placeholder to simulate different sections in the website. Since its just a demo for a portfolio, there isn't actual content here.</p>
            </div>
        );

    }
    
}